<template>
    <DFormRow
        :label="__('customers.contracts.product_plan')"
        :is-required="form.id === undefined"
        :error="errors.product_plan_id"
    >
        <DSelect
            id="product_plan"
            :model-value="modelValue"
            :options="productPlans"
            :placeholder="__('customers.contracts.select_product_plan')"
            :disabled="disabled"
            @update:modelValue="$emit('update:modelValue', $event)"
            @update:value="updateProductPlanId"
        />
    </DFormRow>
</template>

<script>
export default {
    name: 'ProductPlan',
    props: {
        form: {
            type: Object,
            default: () => { return {} }
        },
        modelValue: {
            type: [String, Number],
            default: null
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        productPlans: {
            type: Array,
            default: () => { return [] }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['updateProductPlanId', 'update:modelValue'],
    data () {
        return {
            selectedProductPlan: this.modelValue ?? null
        }
    },
    updated () {
        if (this.productPlans.length === 1) {
            this.selectedProductPlan = this.productPlans[0].value
            this.updateProductPlanId(this.selectedProductPlan)
        }
    },
    methods: {
        updateProductPlanId (value) {
            this.$emit('updateProductPlanId', value)
        }
    }
}
</script>
